import { urlUtils } from 'bundles/utils';
import { URL } from 'bundles/constants';

export const isAdminMerchantView = () => `/${urlUtils.getUrl()}`.includes(URL.ADMINS_MERCHANTS);
export const isAdminConsumersView = () => `/${urlUtils.getUrl()}`.includes(URL.ADMINS_CONSUMERS);
export const isMerchantsSinglePayoutsView = () => `/${urlUtils.getUrl()}`.includes(URL.MERCHANTS_SINGLE_PAYOUTS);

export const isMerchantsBatchPayoutsView = () => `/${urlUtils.getUrl()}`.includes(URL.MERCHANTS_BATCH_PAYOUTS);
